import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/core/services/jwt.service";
import routesMap from "@/helpers/routesMap";
/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    // Vue.axios.defaults.baseURL = "";
    // Vue.axios.defaults.headers.post = {};
    // Vue.axios.defaults.headers.common = {'Content-Type': 'application/json'};
    // Vue.axios.defaults.headers.patch = {};
    // Vue.axios.defaults.headers.put = {};
  },

  /**
   * Set the default HTTP request headers
   */
  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getToken()}`;
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  // get(resource, slug = "") {
  //   return Vue.axios.get(`${resource}`).catch(error => {
  //     throw new Error(`[KT] ApiService ${error}`);
  //   });
  // },
  // getWithToken(resource) {
  //   return Vue.axios.get(resource).catch(error => {
  //     throw new Error(`[KT] ApiService ${error}`);
  //   });
  // },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params) {
    // Vue.axios.defaults.headers.post[
    //   "Content-Type"
    // ] =  'application/json';
    return Vue.axios.post(routesMap.api+resource+'?t='+new Date().getTime(), params
    , 
    {
      headers: {
        'Accept': "application/json, text/plain, */*",
        'Content-Type': "application/json"
      }
    }
    );
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource) {
    return Vue.axios.delete(resource).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  }
};

export default ApiService;
